var service = function($rootScope) {
  $rootScope.sharedReactContext = {}; // to replace passing data to react using localStorage!
  return {
    get: function() {
      return $rootScope.sharedReactContext;
    },
    set: function(key, val) {
      $rootScope.sharedReactContext[key] = val;
      window.sharedContext= $rootScope.sharedReactContext;
    },
    delete: function(key) {
      delete $rootScope.sharedReactContext[key]
    }
  };
};

service.$inject = ['$rootScope'];
tiz.service('SharedReactContext', service);